module.exports = __webpack_public_path__ + "static/a-death-in-the-family-126db054f2f06ee169d27d70c21c88ed.jpg";